import api from "./api";

export interface Notification {
  created_at: string;
  id: number;
  message: string;
  read_at?: string;
  title: string;
  type: string;
  updated_at: string;
  user_id: number;
}

export interface NotificationsResponse {
  data: Notification[];
  meta?: {
    current_page: number;
    from: number;
    last_page: number;
    path: string;
    per_page: number;
    to: number;
    total: number;
  };
  success: boolean;
}

export interface NotificationStats {
  read: number;
  total: number;
  unread: number;
}

export interface NotificationStatsResponse {
  data: NotificationStats;
  success: boolean;
}

const notificationsService = {
  // Delete notification
  deleteNotification: async (id: number): Promise<{ message: string; success: boolean; }> => {
    const response = await api.delete(`/admin/notifications/${id}`);
    return response.data;
  },

  // Get all notifications with pagination
  getNotifications: async (params?: {
    page?: number;
    per_page?: number;
  }): Promise<NotificationsResponse> => {
    const response = await api.get("/admin/notifications", { params });
    
    // Handle both nested and direct response structures
    const notificationsData = response.data.data || response.data;
    const notifications = Array.isArray(notificationsData.data)
      ? notificationsData.data
      : Array.isArray(notificationsData)
        ? notificationsData
        : [];
    
    return {
      data: notifications,
      meta: notificationsData.meta || {
        current_page: 1,
        from: 1,
        last_page: 1,
        path: "",
        per_page: 15,
        to: notifications.length,
        total: notifications.length,
      },
      success: response.data.success ?? true,
    };
  },

  // Get notification stats
  getStats: async (): Promise<NotificationStatsResponse> => {
    const response = await api.get("/admin/notifications/stats");
    return response.data;
  },

  // Mark notification as read
  markAsRead: async (id: number): Promise<{ message: string; success: boolean; }> => {
    const response = await api.patch(`/admin/notifications/${id}/read`);
    return response.data;
  },
};

export default notificationsService;
